import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Checkbox, Spin, Button } from 'antd';
import InfiniteScroll from 'react-infinite-scroll-component';

import * as queryActions from '../../../../../../../data/redux/query_details/actions';

import InputItem from '../../../../../../../components/form/inputitem';
import FaPlusCircle from 'react-icons/lib/fa/plus-circle';
import FaMinusCircle from 'react-icons/lib/fa/minus-circle';
import { log } from "../../../../../../../data/config/utils";
import './index.scss';

class IntentForm extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            intentName: '',
            activePanelId: '',
            selected_utterances: [],
        }
    }

    handleIntentNameChange = event => {
        this.setState({
            [event.target.name]: event.target.value
        })
    }

    loadMoreUtterances = () => {
        const { actions, query_details } = this.props;
        const { activePanelId } = this.state;
        if (activePanelId) {
            var filtered_utterance_data = query_details.utterance_data.find(data => activePanelId === data.id);
        }
        let payload = {
            id: filtered_utterance_data.id,
            limit: 20,
            skip: filtered_utterance_data.utterances.length
        }
        actions.loadMoreUtterances(payload);
    }

    handlePanelChange = id => {
        const { actions } = this.props;
        let payload = {
            id: id,
            limit: 20,
            skip: 0
        }
        if (this.state.activePanelId !== id) {
            actions.getUtterances(payload, () => this.setState({ activePanelId: id }));
        }
        else {
            this.setState({ activePanelId: '' });
        }
    }

    handleCheckboxChange = (utterance, id) => {
        const { selected_utterances } = this.state;
        if (selected_utterances.includes(utterance)) {
            let index = selected_utterances.indexOf(utterance);
            let utterances = [...selected_utterances];
            let new_selected_utterances = utterances.splice(index, 1);
            this.setState({ selected_utterances: new_selected_utterances, activePanelId: id });
        }
        else {
            this.setState({ selected_utterances: [...selected_utterances, utterance], activePanelId: id });
        }
    }

    renderSelectedIntents = () => {
        const { selectedIntents, query_details } = this.props;
        const { utterance_data, loaders } = query_details;
        const { activePanelId } = this.state;
        if (activePanelId) {
            var filtered_utterance_data = utterance_data.find(data => activePanelId === data.id);
        }
        return (
            <Fragment>
                {!loaders.utterance_data_loading ? (
                    <div className="ori-intentform-collapse ori-t-mrgn-10 ori-border-radius-4 ori-line-height-24 ori-border-light ori-font-sm">
                        {
                            selectedIntents.map((data, index) => (

                                <div key={data.id} className="ori-b-border-default ori-height-auto" >
                                    <div className="ori-intentform-collapse-item ori-line-height-24 ori-tb-pad-15 ori-l-pad-25" onClick={() => this.handlePanelChange(data.id)}>
                                        <span>
                                            {activePanelId === data.id ? <FaMinusCircle size={24} /> :
                                                <FaPlusCircle size={24} />
                                            }</span>
                                        <span className="ori-l-mrgn-10">{data.intentName}</span>
                                    </div>
                                    {
                                        activePanelId === data.id ? (
                                            <div id={`panel-${data.id}-${index}`} className="ori-intentform-collapse-content ori-t-pad-5 ori-lr-pad-10  ori-overflow-y-auto">
                                                <InfiniteScroll
                                                    key={`${data.id}-${index}`}
                                                    scrollableTarget={`panel-${data.id}-${index}`}
                                                    dataLength={filtered_utterance_data.utterances.length}
                                                    hasMore={filtered_utterance_data.hasMore}
                                                    scrollThreshold={0.9}
                                                    loader={<div className="ori-text-center"><Spin /></div>}
                                                    next={this.loadMoreUtterances} >
                                                    {
                                                        filtered_utterance_data.utterances
                                                            .map((utterance, index) => (
                                                                <div key={`${data.id}-${index}`} className="ori-flex ori-flex-jsb">
                                                                    <span >{index + 1}. {utterance}</span>
                                                                    <Checkbox
                                                                        key={`checkbox-${data.id}-${index}`}
                                                                        checked={this.state.selected_utterances.includes(utterance) ? true : false}
                                                                        onChange={() => this.handleCheckboxChange(utterance, data.id)} />
                                                                </div>
                                                            ))
                                                    }
                                                </InfiniteScroll>
                                            </div>
                                        ) : null
                                    }
                                </div>
                            ))
                        }
                    </div>
                ) : (
                        <Spin size="large">
                            <div className="ori-intentform-collapse ori-t-mrgn-10 ori-border-radius-4 ori-line-height-24 ori-border-light ori-font-sm">
                                {
                                    selectedIntents.map((data, index) => (

                                        <div key={data.id} className="ori-b-border-default ori-height-auto" >
                                            <div className="ori-intentform-collapse-item ori-line-height-24 ori-tb-pad-15 ori-l-pad-25" onClick={() => this.handlePanelChange(data.id)}>
                                                <span>
                                                    {activePanelId === data.id ? <FaMinusCircle size={24} /> :
                                                        <FaPlusCircle size={24} />
                                                    }</span>
                                                <span className="ori-l-mrgn-10">{data.intentName}</span>
                                            </div>
                                            {
                                                activePanelId === data.id ? (
                                                    <div id={`panel-${data.id}-${index}`} className="ori-intentform-collapse-content ori-t-pad-5 ori-lr-pad-10  ori-overflow-y-auto">
                                                        <InfiniteScroll
                                                            key={`${data.id}-${index}`}
                                                            scrollableTarget={`panel-${data.id}-${index}`}
                                                            dataLength={filtered_utterance_data.utterances.length}
                                                            hasMore={filtered_utterance_data.hasMore}
                                                            scrollThreshold={0.9}
                                                            loader={<div className="ori-text-center"><Spin /></div>}
                                                            next={this.loadMoreUtterances} >
                                                            {
                                                                filtered_utterance_data.utterances
                                                                    .map((utterance, index) => (
                                                                        <div key={`${data.id}-${index}`} className="ori-flex ori-flex-jsb">
                                                                            <span >{index + 1}. {utterance}</span>
                                                                            <Checkbox
                                                                                key={`checkbox-${data.id}-${index}`}
                                                                                checked={this.state.selected_utterances.includes(utterance) ? true : false}
                                                                                onChange={() => this.handleCheckboxChange(utterance, data.id)} />
                                                                        </div>
                                                                    ))
                                                            }
                                                        </InfiniteScroll>
                                                    </div>
                                                ) : null
                                            }
                                        </div>
                                    ))
                                }
                            </div>
                        </Spin>
                    )}
            </Fragment>

        );
    }

    render() {
        log('Intent Form rendering...')
        const { intentName } = this.state;
        const { closeDrawer } = this.props;
        const inputItemDetails = {
            title: "Name of new intent",
            placeholder: "Enter intent name",
            name: 'intentName'
        }
        return (
            <div className="ori-tb-pad-10 ori-lr-pad-15 ori-full-parent-height ori-overflow-auto">
                <InputItem
                    title={inputItemDetails.title}
                    placeholder={inputItemDetails.placeholder}
                    name={inputItemDetails.name}
                    value={intentName}
                    onChange={this.handleIntentNameChange} />
                <div className="ori-t-mrgn-20">
                    Please select utterances for the new intent
                </div>
                {this.renderSelectedIntents()}
                <div className="ori-absolute ori-full-width ori-align-bottom ori-b-pad-5 ori-align-left">
                    <div className="ori-pad-10 ori-flex-row ori-flex-jc">
                        <Button className="ori-lr-mrgn-5 ori-border-radius-20" type="default" onClick={closeDrawer}>Cancel</Button>
                        <Button className="ori-lr-mrgn-5 ori-border-radius-20" type="primary">Save Intent</Button>
                    </div>
                </div>
            </div>
        )
    }

}

const mapStateToProps = state => {
    return {
        query_details: state.query_details
    };
};

const mapDispatchToProps = dispatch => {
    return {
        actions: bindActionCreators(Object.assign({}, queryActions), dispatch),
    };
};

IntentForm.propTypes = {
    selectedIntents: PropTypes.array,
    closeDrawer: PropTypes.func,
    query_details: PropTypes.object,
    actions: PropTypes.object,
}

export default connect(mapStateToProps, mapDispatchToProps)(IntentForm);





// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/analytics/queryanalytics/components/intentform/index.js